import { userInfo, csrfTokenData } from "./contexts/__data__/index";
import {
  subscriptionTabResources,
  unsubscribeOrg,
} from "./components/SubscriptionTab/__data__";
import dataReceiptFileTypes from "./components/DataReceipt/__data__";
import { userGroups, searchResults } from "./components/Organization/__data__";
import {
  manifestDetails,
  createResourceData,
} from "./components/CreateResource/__data__";
import {
  resourceVersionList,
  resourceVersionDetails,
  orgSubscribedByResourceVersion,
} from "./components/ResourceVersionsList/__data__";
import {
  orgsList,
  subscribedResourcesToOrgs,
} from "./components/SubscribeOrganizations/__data__";
import { deprecateVersionExample } from "./components/OrganisationDetailsDataGrid/__data__";
import {
  allEnvironmentsData,
  updatedEnvironmentData,
  deletedEnvironmentResponse,
  dataReceiptFileTypesMockData,
} from "./components/Environments/__data__";
import {
  mockCreateEnvironmentData,
  mockUpdateEnvironmentData,
  mockUpdatedEnvironmentResponse,
  mockCertificateDetail,
} from "./components/CreateEditEnvironment/__data__";
import {
  organizationData,
  childOrganizationData,
  allUserGroups,
  searchOrganisation,
} from "./components/OrganizationTree/__data__";
import {
  createOrganization,
  updateOrganization,
} from "./components/CreateEditOrganization/__data__";

class MockApi {
  constructor() {
    this.userInfo = userInfo;
    this.subscriptionTabResources = subscriptionTabResources;
    this.dataReceiptFileTypes = dataReceiptFileTypes;
    this.organizationData = organizationData;
    this.manifestDetails = manifestDetails;
    this.csrfTokenData = csrfTokenData;
    this.manifestDetails = manifestDetails;
    this.cancelmanifest = true;
    this.createResourceData = createResourceData;
    this.resourceVersionList = resourceVersionList;
    this.deprecateResource = deprecateVersionExample;
    this.deprecateResourceVersion = deprecateVersionExample;
    this.resourceVersionDetails = resourceVersionDetails;
    this.orgSubscribedByResourceVersion = orgSubscribedByResourceVersion;
    this.orgsList = orgsList;
    this.subscribedResourcesToOrgs = subscribedResourcesToOrgs;
    this.allEnvironmentsData = allEnvironmentsData;
    this.updatedEnvironmentData = updatedEnvironmentData;
    this.deletedEnvironmentResponse = deletedEnvironmentResponse;
    this.dataReceiptFileTypesMockData = dataReceiptFileTypesMockData;
    this.mockCreateEnvironmentData = mockCreateEnvironmentData;
    this.mockUpdateEnvironmentData = mockUpdateEnvironmentData;
    this.mockUpdatedEnvironmentResponse = mockUpdatedEnvironmentResponse;
    this.mockCertificateDetail = mockCertificateDetail;
    this.allUserGroups = allUserGroups;
    this.searchOrganization = searchOrganisation;
    this.searchResults = searchResults;
    this.userGroups = userGroups;
    this.createOrganization = createOrganization;
    this.updateOrganization = updateOrganization;
    this.childOrganizationData = childOrganizationData;
    this.unsubscribeOrg = unsubscribeOrg;
  }

  async callUserDetails() {
    return this.userInfo;
  }

  async getCSRFToken() {
    return this.csrfTokenData;
  }

  async callSubscriptionTabResourceList() {
    return this.subscriptionTabResources;
  }

  async callDataReceiptFileTypes() {
    return this.dataReceiptFileTypes;
  }

  async callGetRootOrg() {
    return this.organizationData;
  }

  async callGetManifestDetails() {
    return this.manifestDetails;
  }

  async callCreateResource() {
    return this.createResourceData;
  }

  async callCreateResourceVersion() {
    return this.createResourceData;
  }

  async callAllResourceVersionsList() {
    return this.resourceVersionList;
  }

  async callOrgAdminResourceVersionsList() {
    return this.resourceVersionList;
  }

  async callCancelResourceUpdate() {
    return this.cancelmanifest;
  }

  async callDeprecateResource() {
    return this.deprecateResource;
  }

  async callDeprecateResourceVersion() {
    return this.deprecateResourceVersion;
  }

  async callResourceVersionDetails() {
    return this.resourceVersionDetails;
  }

  async callOrganisationSubscribedToResourceVersion() {
    return this.orgSubscribedByResourceVersion;
  }

  async callAllUserGroups() {
    return this.allUserGroups;
  }

  async getPartnerOrgs() {
    return this.orgsList;
  }

  async createMultiOrgSubscriptionForResource() {
    return this.subscribedResourcesToOrgs;
  }

  async callAllEnvByOrgId() {
    return Promise.resolve(this.allEnvironmentsData);
  }

  async callUpdateEnvironment() {
    return Promise.resolve(this.updatedEnvironmentData);
  }

  async callDeleteEnvironment() {
    return Promise.resolve(this.deletedEnvironmentResponse);
  }

  async callDataRecieptFileTypesForDataReceipts() {
    return Promise.resolve(this.dataReceiptFileTypesMockData);
  }

  async callCreateEnvironment() {
    return this.mockCreateEnvironmentData;
  }

  async callUpdatedEnvironmentResponse() {
    return this.mockUpdatedEnvironmentResponse;
  }

  async callGetCertificateDetails() {
    return this.mockCertificateDetail;
  }

  async callAllUserGropus() {
    return this.userGroups;
  }

  async callGetAllSearchOrganization() {
    return this.searchResults;
  }

  async callAllOrganizationsWithChildPartners() {
    return this.childOrganizationData;
  }

  async callCreatePartnerOrganization() {
    return this.createOrganization;
  }

  async callUpdateOrganization() {
    return this.updateOrganization;
  }

  async callUnSubscribeResourceVersion() {
    return this.unsubscribeOrg;
  }
}
export default MockApi;
